import { Entity, IEntity } from '@lycoris-nubila/ngx-lycoris';
import { Observable, of } from 'rxjs';

import { TaskType } from 'task/model/task.type';

import { IModuleTaskI18n, ModuleTaskI18n } from './module-task-i18n';

export interface IModuleTask extends IEntity {
	readonly type: TaskType;
	readonly position: number;
	readonly localizations: ReadonlyArray<IModuleTaskI18n>;
	readonly localization$: Observable<IModuleTaskI18n>;
}

export class ModuleTask extends Entity implements IModuleTask {
	private _type: TaskType;
	private _position: number;
	private _localizations: ModuleTaskI18n[];
	private _localization$: Observable<ModuleTaskI18n>;

	constructor(
		id: string,
		type: TaskType,
		position: number,
		updateTimestamp: number,
		localizations: ModuleTaskI18n[],
		localization$: Observable<ModuleTaskI18n> = of(null)
	) {
		super(id, null, updateTimestamp);
		this._type = type;
		this._position = position;
		this._localizations = localizations;
		this._localization$ = localization$;
	}

	public get type(): TaskType {
		return this._type;
	}

	public get position(): number {
		return this._position;
	}

	public get localizations(): ModuleTaskI18n[] {
		return this._localizations;
	}

	public get localization$(): Observable<ModuleTaskI18n> {
		return this._localization$;
	}
}
